module.exports = __webpack_public_path__ + "media/Celular 3.08a3d57e.mp4";